export const LEFT_DRAWER_WIDTH = 500;
export const RIGHT_DRAWER_WIDTH = 330;

const dimensions = {
  topNav: {
    height: 49,
  },
  sideNav: {
    width: 8 * 7,
  },
  leftSidebar: {
    width: LEFT_DRAWER_WIDTH,
  },
  rightSidebar: {
    width: RIGHT_DRAWER_WIDTH,
  },
  statusbar: {
    height: 8 * 3,
  },
};

export default dimensions;
